import { render, staticRenderFns } from "./wxBindPopup.vue?vue&type=template&id=204ab2c8&scoped=true&"
import script from "./wxBindPopup.vue?vue&type=script&lang=js&"
export * from "./wxBindPopup.vue?vue&type=script&lang=js&"
import style0 from "./wxBindPopup.vue?vue&type=style&index=0&id=204ab2c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204ab2c8",
  null
  
)

export default component.exports